<div class="">
  <button
    class="btn btn-info ml-3"
    type="button"
    (click)="downloadAsPDF()"
  >
   Export PDF
  </button>
</div>
